// NOTE: NSAI-6791 — a paste at least this many lines long leaves the draft and
// becomes a "Pasted text" card in the composer, so a pasted document can no
// longer stretch the composer over several screens. Anything shorter pastes
// inline exactly as before. Tune it here; web and mobile both read it.
export const PASTED_TEXT_CARD_MIN_LINES = 100 as const;

// NOTE: NSAI-6791 — the same move for a paste that is long but has few line
// breaks (minified code, a wall of prose, a CSV with very wide rows). 8 000
// characters is the line threshold at a typical 80 characters per line, so
// both triggers fire at roughly the same amount of text on screen.
export const PASTED_TEXT_CARD_MIN_CHARACTERS = 8000 as const;

// NOTE: How much of the paste the card shows. The tile flows the opening lines
// together and clamps them, so it needs enough text to fill a few lines even
// when the paste starts with short ones; the character cap keeps one huge
// line from being copied into the card wholesale.
export const PASTED_TEXT_SNIPPET_MAX_LINES = 8 as const;
export const PASTED_TEXT_SNIPPET_MAX_CHARACTERS = 240 as const;

// NOTE: The kind is guessed from a bounded sample, so labelling a very large
// paste costs the same as labelling a small one. The first lines of a file are
// where its shape shows (imports, a heading, an opening brace).
export const PASTED_TEXT_KIND_SAMPLE_LINES = 200 as const;

// NOTE: Ratios of structural lines (among non-blank sampled lines) above which
// a paste reads as code or as Markdown rather than as prose.
export const PASTED_TEXT_CODE_LINE_RATIO = 0.3 as const;
export const PASTED_TEXT_MARKDOWN_LINE_RATIO = 0.2 as const;

// NOTE: How each pasted block is separated from the instruction and from the
// next block in the message that is sent. A blank line keeps them visibly
// apart in the user's own bubble, which renders the raw text.
export const PASTED_TEXT_MESSAGE_SEPARATOR = "\n\n" as const;

// NOTE: NSAI-6791 — each paste travels inside the message body between an
// opening line `<pasted_text chars="N">` (N = the paste's exact length) and a
// closing `</pasted_text>` line, so the transcript can draw it as a card again
// after a send: the stored message is plain text, with no separate field for
// it. XML-style tags are also how models are told "this is a document the user
// supplied". See buildPastedTextOpenTag for why the length is carried.
export const PASTED_TEXT_TAG_NAME = "pasted_text" as const;
export const PASTED_TEXT_LENGTH_ATTRIBUTE = "chars" as const;
export const PASTED_TEXT_CLOSE_TAG = "</pasted_text>" as const;

// NOTE: Above this size a bracketed paste is labelled JSON from its shape alone,
// so editing a very large card does not re-parse the whole document per
// keystroke.
export const PASTED_TEXT_JSON_PARSE_MAX_CHARACTERS = 200_000 as const;
